'use client';

export * from './native-data';
